import  { useState } from 'react';
import Box from '@mui/material/Box';
import { StyledAccordionContainer, StyledLeadContainer,  } from '../../Components/Styled/index';
import { ACTIVE_STATUS, handleValidateCodevalue, INVOICE_STATUS} from '../../Utility/constant';
import { ChooseProductType } from '../../Components/ChooseProductType';
import { useSelector } from 'react-redux';
import { WhoColumns } from '../../Components/WhoColumns';
import TextFiledWithLabel from '../../Components/TextFieldWithLabel';
import AutoCompleteComponent from '../../Components/AutoCompleteComponenet';
import './invoice.css';

const SearchInvoice = ({handleSelectOwner,handleSelectStatus, ownerlistdropdown , entityDetails ,handleOnChange , customerdropdown }) => {
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const [isVisible , setIsVisible] = useState(false)
    const invoiceStatusData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == INVOICE_STATUS)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);  

    return (
        <Box className="invoice-search-fields"><StyledLeadContainer>
            <TextFiledWithLabel
                        id = "id"
                        name="id"
                        label={handleValidateCodevalue(internationalise,'INV_SEARCH_INV_ID')}
                        type = "number"
                        handleOnChange={handleOnChange}
                        value={entityDetails?.id}
                        className="invoice-search-id-field"
                                    
            /> 
                <TextFiledWithLabel 
                id="orderId" 
                label={handleValidateCodevalue(internationalise,'INV_SEARCH_ORD_ID')} 
                name="orderId"
                type = "number"
                handleOnChange={handleOnChange}
                value={entityDetails?.orderId}
                />
                                <AutoCompleteComponent
                    isOwner = {true}
                    optionSet = {customerdropdown}
                    value={entityDetails?.selectedCustomer|| null}
                    name = "selectedCustomer"
                    placeholder={handleValidateCodevalue(internationalise,'SO_SEARCH_CUSTOMER')}
                    label={handleValidateCodevalue(internationalise,'SO_SEARCH_CUSTOMER')}
                    onChange={(event, Owner) => handleSelectOwner(event, Owner,"Customer")}
                />
                 <ChooseProductType
                    value={entityDetails?.productId || ""}
                    searchState={entityDetails}
                    handleChangeSearchField={handleOnChange} 
                />

            </StyledLeadContainer>
            <StyledAccordionContainer>
                <AutoCompleteComponent
                    multiple
                    className="invoice-search-autocomplete"
                    limitTags={3}
                    optionSet = {ownerlistdropdown}
                    value={entityDetails?.selectedOwner || []}
                    name = "ownerId"
                    placeholder={handleValidateCodevalue(internationalise,'INV_SEARCH_OWNER')}
                    disabled = {!(specificRolePermission?.isAllInvoiceManage || specificRolePermission?.isInvoiceTeamManage)}
                    label={handleValidateCodevalue(internationalise,'INV_SEARCH_OWNER')}
                    onChange={(event, Owner) => handleSelectOwner(event, Owner)}
                />
                <AutoCompleteComponent
                    multiple
                    className="invoice-search-autocomplete"
                    limitTags={3}
                    isLookup = {true}
                    optionSet = {invoiceStatusData}
                    value={entityDetails?.status|| []}
                    name = "status"
                    placeholder={handleValidateCodevalue(internationalise,'INV_SEARCH_STATUS')}
                    label={handleValidateCodevalue(internationalise,'INV_SEARCH_STATUS')}
                    onChange={(event, Status) => handleSelectStatus(event, Status,"status")}
                />
            </StyledAccordionContainer>
            <WhoColumns
            searchState={entityDetails}
            handleOnChange={handleOnChange}
            />
        </Box>
    );
}

export default SearchInvoice;
